import React, { useEffect, useRef, useState } from 'react'
import { useBranding } from '../context/BrandingContext';
import axios from 'axios';
import { API_URL, getCookie, getHeaders } from '../helper/commonApi';
import { useNavigate } from 'react-router-dom';
import GreInstructionsModal from '../components/Modals/GreInstructionsModal';
import Loader from '../components/loader';
import CalculatorPopup from '../components/Modals/CalculatorPopup';
import Review from '../components/Review/Review';
import toast from 'react-hot-toast';
import LoginPopup from '../components/Modals/LoginPopup';

const TestComponents = () => {
    const { colors } = useBranding();
    // const [searchParams] = useSearchParams();
    // const testId = searchParams.get("test_id");
    const testId = localStorage.getItem('_GRE_test_id');

    const userId = localStorage.getItem('_register_GRE_LOGIN_userId');
    const sessionKey = `testSession_${testId}_${userId}`;
    const MARKED_KEY = `testMarked_${testId}_${userId}`;

    const navigate = useNavigate();

    const [showLogin, setShowLogin] = useState(false);

    // --- UI state
    const [isOpen, setIsOpen] = useState(false);
    const [showQuitPopup, setShowQuitPopup] = useState(false);
    const [showExitPopup, setShowExitPopup] = useState(false);
    const [showCalc, setShowCalc] = useState(false);
    const [showReview, setShowReview] = useState(false);
    const [showTimer, setShowTimer] = useState(true);


    const [loading, setLoading] = useState(false)
    const [isQuestionLoading, setIsQuestionLoading] = useState(false);

    // --- Question handling
    // const [currentIndex, setCurrentIndex] = useState(0);
    const [question, setQuestion] = useState(null); // always object, never array
    const [currentQuestion, setCurrentQuestion] = useState([]); // always object, never array
    const [currentSectionId, setCurrentSectionId] = useState(null);
    const [sections, setSections] = useState([]);
    const [reSume, setResume] = useState(false);
    // const [questionAnswerCount, setQuestionAnswerCount] = useState(null);
    const [timer, setTimer] = useState({ minutes: 0, seconds: 0 });

    // Local answers
    const localEssay = localStorage.getItem(`essay_answer`);
    const [essayAnswer, setEssayAnswer] = useState(localEssay || "");

    const [inputAnswer, setInputAnswer] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [singleSection, setSingleSection] = useState(null);
    const [startResumeTestError, setStartResumeTestError] = useState("");

    const section = sections?.find(sec => sec?.section_id === currentSectionId);

    // Instruction time spent tracker
    const [instructionSeconds, setInstructionSeconds] = useState(0);
    const instructionIntervalRef = useRef(null);

    // Timer control
    // const [isTimerPaused, setIsTimerPaused] = useState(false);
    // const [pauseSeconds, setPauseSeconds] = useState(0);
    // const pauseIntervalRef = useRef(null);


    const [reviewData, setReviewData] = useState([]);

    const buildReviewData = () => {
        const session = JSON.parse(localStorage.getItem(sessionKey) || "[]");
        const markedObj = JSON.parse(localStorage.getItem(MARKED_KEY) || '{}');
        const data = session.map((q, idx) => ({
            number: idx + 1,
            status: q.answer ? (q.answer === "" ? "Not Answered" : "Answered") : "Not Encountered",
            marked: !!markedObj[q.id],
        }));
        setReviewData(data);
    };


    // Fetch first question / resume test
    useEffect(() => {
        const jwtToken = getCookie('_GRE_JWT_TOKEN');

        if (!userId) {
            localStorage.clear();
            document.cookie = "_GRE_JWT_TOKEN=; max-age=0; path=/;";
            navigate('/')
            return;
        }

        if (!jwtToken) {
            document.cookie = "_GRE_JWT_TOKEN=; max-age=0; path=/;";
            setShowLogin(true);
            // handleStopTimer();
            return;
        }

        getStartTest();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleLoginSuccess = () => {
        setShowLogin(false);
        // handleStartTimer();
        getStartTest(); // continue test after login
    };

    //  ==== Pause / Resume Timer ====
    // const handleStopTimer = () => {
    //     if (isTimerPaused) return; // already paused

    //     setIsTimerPaused(true);

    //     // Start counting paused seconds locally
    //     pauseIntervalRef.current = setInterval(() => {
    //         setPauseSeconds(prev => prev + 1);
    //     }, 1000);
    // };

    // const handleStartTimer = async () => {
    //     if (!isTimerPaused) return; // already running

    //     setIsTimerPaused(false);

    //     // Stop pause counter
    //     clearInterval(pauseIntervalRef.current);

    //     // Send pause duration to API
    //     if (pauseSeconds > 0) {
    //         try {
    //             await axios.post(
    //                 `${API_URL}/instruction-time-spent`,
    //                 {
    //                     assigned_test_id: testId,
    //                     user_id: userId,
    //                     section_id: currentSectionId,
    //                     seconds: pauseSeconds,   // total paused seconds
    //                 },
    //                 { headers: getHeaders() }
    //             );
    //             // console.log("Pause duration sent:", pauseSeconds);
    //         } catch (err) {
    //             toast.error("Error logging pause time");
    //             console.error("Pause API error:", err);
    //         }
    //         setPauseSeconds(0);
    //     }
    // };


    // Restore session on mount
    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem(sessionKey) || "[]");
        if (stored.length > 0) {
            const lastIdx = stored.length - 1;
            // setCurrentIndex(lastIdx);
            restoreAnswer(stored[lastIdx]);
        }
        // else {
        //     getStartTest();
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const restoreAnswer = (entry) => {
        if (!entry) return;

        // Restore marked state properly
        const marked = getMarkedState(entry.data.id);

        // Reset inputs if answer is empty
        if (!entry.answer) {
            setEssayAnswer("");
            setInputAnswer("");
            setSelectedOptions([]);
        } else {
            // if (entry.data?.question_type === "AW") setEssayAnswer(entry.answer || "");
            // else if (entry.data?.input_field === "input" || entry.data?.input_field === "Input") setInputAnswer(entry.answer || "");
            // else if (entry.answer) setSelectedOptions(entry.answer.split(","));
            if (entry.data?.category === "Analytical") setEssayAnswer(entry.answer);
            else if (entry.data?.input_field?.toLowerCase() === "input") setInputAnswer(entry.answer);
            else setSelectedOptions(entry.answer.split(","));
        }
        setQuestion({ ...entry.data, marked });
    };


    // Start counter ONLY when modal is open
    useEffect(() => {
        if (isOpen) {
            instructionIntervalRef.current = setInterval(() => {
                setInstructionSeconds(prev => prev + 1);
            }, 1000);
        } else {
            clearInterval(instructionIntervalRef.current);
        }

        return () => clearInterval(instructionIntervalRef.current);
    }, [isOpen]);



    const getStartTest = async () => {
        setLoading(true);
        try {
            const res = await axios.post(
                `${API_URL}/start-resume-test`,
                { assigned_test_id: testId, user_id: userId },
                { headers: getHeaders() }
            );

            if (!res.data?.status) {
                setLoading(false);
                setStartResumeTestError(res?.data?.message);
                return;
            }

            if (res.status === 200) {
                const data = res.data.data;

                if (!data?.is_resume) {
                    // First time → show instructions for 60s
                    setLoading(true);
                    setIsOpen(true);

                    // auto close after 1 min
                    setTimeout(() => {
                        handleStartAfterInstructions();
                    }, 60000);

                    return;
                }
                else {
                    // ✅ Normalize question (always object)
                    // const firstQuestion = Array.isArray(data?.current_question)
                    //     ? data.current_question[0]
                    //     : data.current_question;

                    // const firstQuestion = Array.isArray(data?.current_question)
                    //     ? data?.current_question[data?.current_question?.length - 1] // last element
                    //     : data?.current_question;

                    // setQuestion(firstQuestion);
                    // ✅ Build session array from all answered questions
                    const questionsArray = Array.isArray(data?.current_question)
                        ? data.current_question
                        : [data.current_question];

                    const session = questionsArray.map((q) => ({
                        id: q.id,
                        data: q,
                        answer: q.user_answer === "unanswered" ? "" : q.user_answer || "",
                    }));


                    // Store all answered questions in localStorage
                    localStorage.setItem(sessionKey, JSON.stringify(session));

                    // Restore last answered as current
                    const lastQuestion = questionsArray[questionsArray.length - 1];
                    setQuestion(lastQuestion);
                    restoreAnswer(session[session.length - 1]);

                    setCurrentSectionId(data?.current_section);
                    setTimer(data?.section_timer_remaining);
                    setSections(data?.sections);
                    setResume(data?.is_resume);
                    setCurrentQuestion(data?.current_question)

                    // const session = [{ id: firstQuestion.id, data: firstQuestion, answer: "", marked: false }];
                    // localStorage.setItem(sessionKey, JSON.stringify(session));

                    // toast.success(res.data.message)
                }
                setLoading(false);
            }
        } catch (err) {
            toast.err(err)
            console.error("Error fetching test start:", err);
            setLoading(false);
        }
    };

    const handleStartAfterInstructions = async () => {
        setIsOpen(false);
        setLoading(false);

        clearInterval(instructionIntervalRef.current);

        if (instructionSeconds > 0) {
            setLoading(true);
            // console.log("Instruction time spent (s):", instructionSeconds);
            await sendInstructionTime(instructionSeconds); // send total time spent
            setInstructionSeconds(0); // reset counter
            setLoading(false);
        }

        await getStartTest();
    };

    const sendInstructionTime = async (seconds) => {
        try {
            await axios.post(
                `${API_URL}/instruction-time-spent`,
                {
                    assigned_test_id: testId,
                    user_id: userId,
                    section_id: 1,
                    seconds,
                },
                { headers: getHeaders() }
            );
        } catch (err) {
            toast.error(err)
            console.error("Error sending instruction time:", err);
        }
    };

    // Countdown timer
    // useEffect(() => {
    //     if (!timer?.minutes && !timer?.seconds) return;
    //     const interval = setInterval(() => {
    //         setTimer((prev) => {
    //             let { minutes, seconds } = prev;
    //             if (seconds === 0) {
    //                 if (minutes === 0) {
    //                     clearInterval(interval);
    //                     // handleSubmitQuestion();
    //                     handleSubmitSection();
    //                     return prev;
    //                 }
    //                 minutes -= 1;
    //                 seconds = 59;
    //             } else {
    //                 seconds -= 1;
    //             }
    //             return { minutes, seconds };
    //         });
    //     }, 1000);
    //     return () => clearInterval(interval);
    // }, [timer?.minutes, timer?.seconds]);

    useEffect(() => {
        if (!timer?.minutes && !timer?.seconds) return;
        // if (isTimerPaused) return; // ⛔ freeze countdown if paused

        const interval = setInterval(() => {
            setTimer((prev) => {
                let { minutes, seconds } = prev;
                if (seconds === 0) {
                    if (minutes === 0) {
                        clearInterval(interval);
                        handleSubmitSection();
                        return prev;
                    }
                    minutes -= 1;
                    seconds = 59;
                } else {
                    seconds -= 1;
                }
                return { minutes, seconds };
            });
        }, 1000);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timer?.minutes, timer?.seconds]);


    const saveAnswerLocally = (qid, answer) => {
        const session = JSON.parse(localStorage.getItem(sessionKey) || "[]");
        const idx = session.findIndex(q => q.id === qid);
        if (idx >= 0) {
            session[idx].answer = answer;
        } else {
            session.push({ id: qid, data: question, answer });
        }
        localStorage.setItem(sessionKey, JSON.stringify(session));
    };

    // --------  Question Submit
    // const handleSubmitQuestion = async () => {
    //     setIsQuestionLoading(true);
    //     try {

    //         const answer =
    //             question?.question_type === "AW"
    //                 ? essayAnswer
    //                 : question?.input_field?.toLowerCase() === "input"
    //                     ? inputAnswer
    //                     : selectedOptions.sort().join(",");


    //         saveAnswerLocally(question?.id, answer);

    //         const res = await axios.post(
    //             `${API_URL}/submit-question`,
    //             {
    //                 user_id: userId,
    //                 assigned_test_id: testId,
    //                 question_id: question?.id, //  unified format
    //                 section_id: currentSectionId,
    //                 difficulty: 8,
    //                 // answer,
    //                 // answer:
    //                 //     question?.question_type === "AW"
    //                 //         ? essayAnswer
    //                 //         : selectedOptions.join(","),
    //                 answer:
    //                     question?.question_type === "AW"
    //                         ? essayAnswer
    //                         : question?.input_field?.toLowerCase() === "input"
    //                             ? inputAnswer
    //                             : selectedOptions.sort().join(","),
    //             },
    //             { headers: getHeaders() }
    //         );


    //         if (res.status === 200) {
    //             const data = res.data.data;

    //             if (!res?.data?.status) {
    //                 toast.error(res?.data?.message || "Error submitting question");
    //             }

    //             setIsQuestionLoading(false);

    //             if (data?.section_complete) {
    //                 setShowQuitPopup(true);
    //                 // await handleSubmitSection();
    //                 return;
    //             }

    //             // Next question
    //             if (data?.next_question) {

    //                 const session = JSON.parse(localStorage.getItem(sessionKey) || "[]");
    //                 session.push({ id: data.next_question.id, data: data.next_question, answer: "" });
    //                 localStorage.setItem(sessionKey, JSON.stringify(session));
    //                 setCurrentIndex(session.length - 1);
    //                 restoreAnswer(session[session.length - 1]);

    //                 setQuestion(data.next_question);
    //             }

    //             if (data?.questions_answered) {
    //                 setQuestionAnswerCount(data?.questions_answered)
    //             }

    //             if (data?.next_difficulty) {
    //                 setQuestionDifficulty(data?.next_difficulty)
    //             }
    //             setInputAnswer("");
    //             setSelectedOptions([]);
    //             // toast.success(res.data.message)

    //         }
    //     } catch (err) {
    //         toast.error(err)
    //         console.error("Error submitting question:", err);
    //         setIsQuestionLoading(false);

    //     }
    // };

    const handleSubmitQuestion = async () => {
        setIsQuestionLoading(true);

        try {
            let session = JSON.parse(localStorage.getItem(sessionKey) || "[]");

            const currentIdx = session.findIndex(q => q.id === question?.id);
            const isBackQuestion = currentIdx !== session.length - 1;
            const is_updated = isBackQuestion ? 1 : 0;

            const answer =
                question?.input_field?.toLowerCase() === "textarea"
                    ? essayAnswer
                    : question?.input_field?.toLowerCase() === "input"
                        ? inputAnswer
                        : selectedOptions.sort().join(",");

            // update current stored question only
            session[currentIdx].answer = answer;
            session[currentIdx].is_updated = is_updated;
            localStorage.setItem(sessionKey, JSON.stringify(session));

            // API call
            const res = await axios.post(`${API_URL}/submit-question`,
                {
                    user_id: userId,
                    assigned_test_id: testId,
                    question_id: question?.id,
                    section_id: currentSectionId,
                    difficulty: 8,
                    answer,
                    is_updated,
                },
                { headers: getHeaders() }
            );

            if (res?.data?.message === "Unauthorized. Invalid API Key or JWT Token.") {
                setShowLogin(true);
                setIsQuestionLoading(false);
                return;
            }

            if (res.status !== 200) {
                setIsQuestionLoading(false);
                return;
            }

            const data = res.data.data;
            setIsQuestionLoading(false);

            if (!res.data.status) {
                toast.error(res.data.message || "Error submitting");
            }

            if (data?.section_complete) {
                setShowQuitPopup(true);
                return;
            }

            // ======================================================
            //        NEXT QUESTION HANDLING (INDEX BASED)
            // ======================================================

            session = JSON.parse(localStorage.getItem(sessionKey) || "[]");

            // CASE A: API sent next question → ALWAYS treat as NEW
            if (data?.next_question) {

                // push at END always (new position)
                session.push({
                    id: data.next_question.id,
                    data: data.next_question,
                    answer: "",
                    is_updated: 0,
                });

                localStorage.setItem(sessionKey, JSON.stringify(session));

                // Now move to this NEW LAST question
                const nextIndex = session.length - 1;

                // reset first
                setInputAnswer("");
                setSelectedOptions([]);

                // then show stored question with stored answer
                // setCurrentIndex(nextIndex);
                setQuestion(session[nextIndex].data);
                restoreAnswer({ data: session[nextIndex].data, answer: "" });

                return;
            }

            // CASE B: API did NOT send next question → move forward in session
            if (is_updated === 1) {
                const nextIndex = currentIdx + 1;

                if (nextIndex < session.length) {
                    const nextStored = session[nextIndex];

                    // Reset answers if new question (empty answer)
                    if (!nextStored.answer) {
                        setInputAnswer("");
                        setSelectedOptions([]);
                    }

                    // setCurrentIndex(nextIndex);
                    setQuestion(nextStored.data);
                    restoreAnswer(nextStored);
                    return;
                }
            }

            // CASE C: no next question (end)
            // nothing else

        } catch (err) {
            setIsQuestionLoading(false);
            toast.error(err);
            console.error("Error submitting:", err);
        }
    };

    //  ----- Section Submit
    const handleSubmitSection = async () => {
        try {
            const res = await axios.post(
                `${API_URL}/submit-section`,
                { assigned_test_id: testId, user_id: userId, section_id: currentSectionId },
                { headers: getHeaders() }
            );

            if (res.status === 200) {
                const data = res.data.data;
                setShowQuitPopup(false);
                localStorage.removeItem(sessionKey);
                localStorage.removeItem(MARKED_KEY);
                localStorage.removeItem('essay_answer')

                if (data?.test_status === "completed") {
                    toast.success(res.data.message)
                    // navigate("/dashboard")
                    navigate(`/result?tid=${testId}`)
                    return;
                }

                if (data?.next_question) {
                    const session = JSON.parse(localStorage.getItem(sessionKey) || "[]");
                    session.push({ id: data.next_question.id, data: data.next_question, answer: "" });
                    localStorage.setItem(sessionKey, JSON.stringify(session));

                    setQuestion(data?.next_question);
                }

                if (data?.next_section) {
                    setSingleSection(data?.next_section); // normalize to array
                    setCurrentSectionId(data?.next_section?.section_id);
                }

                if (data?.section_timer_remaining) {
                    setTimer(data?.section_timer_remaining);
                }
                // setQuestionAnswerCount(1);
                setInputAnswer("");
                setSelectedOptions([]);
                toast.success(res.data.message)
            }
        } catch (err) {
            toast.error(err)
            console.error("Error submitting section:", err);
        }
    };

    const handleExit = async () => {
        try {
            const res = await axios.post(
                `${API_URL}/remove-answer`,
                { assigned_test_id: testId, user_id: userId, section_id: currentSectionId },
                { headers: getHeaders() }
            );

            if (res.status === 200) {
                toast.success(res.data.message)
                navigate("/dashboard")
            }
        } catch (err) {
            toast.error(err)
            // setIsQuestionLoading(false);
            console.error("Error submitting section:", err);
        }
    }

    // Auto analytic update every 1 min
    useEffect(() => {
        if (!question?.id || !currentSectionId) return;

        // Only set interval if section 1 and AW
        if (currentSectionId === 1 && question?.category === "Analytical") {
            const interval = setInterval(() => {
                sendAnalyticUpdate();
            }, 60000);

            return () => clearInterval(interval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [question?.id, currentSectionId]);

    //  API calls
    const sendAnalyticUpdate = async () => {
        try {
            await axios.post(
                `${API_URL}/update-answer`,
                {
                    assigned_test_id: testId,
                    user_id: userId,
                    section_id: currentSectionId,
                    question_id: question?.id,
                    answer: localEssay,
                },
                { headers: getHeaders() }
            );
            // console.log("Analytic update sent");
        } catch (err) {
            toast.error(err)
            console.error("Error sending analytic update:", err);
        }
    };

    // Build options safely
    const options = [
        question?.choiceA,
        question?.choiceB,
        question?.choiceC,
        question?.choiceD,
        question?.choiceE,
        question?.choiceF,
        question?.choiceG,
        question?.choiceH,
        question?.choiceI,
        question?.choiceJ,
    ].filter(Boolean);

    const handleBack = () => {
        const session = JSON.parse(localStorage.getItem(sessionKey) || "[]");
        const idx = session.findIndex(q => q.id === question?.id);

        if (idx > 0) {
            const prevIndex = idx - 1;
            // setCurrentIndex(prevIndex);
            // setQuestion(session[prevIndex].data);
            restoreAnswer(session[prevIndex]);
        }
    };

    const getMarkedState = (qid) => {
        const markedObj = JSON.parse(localStorage.getItem(MARKED_KEY) || '{}');
        return !!markedObj[qid];
    };

    const setMarkedState = (qid, value) => {
        const markedObj = JSON.parse(localStorage.getItem(MARKED_KEY) || '{}');
        markedObj[qid] = value;
        localStorage.setItem(MARKED_KEY, JSON.stringify(markedObj));
    };

    const handleMark = () => {
        if (!question) return;
        const current = getMarkedState(question.id);
        const newMarked = !current;
        setMarkedState(question.id, newMarked);

        // update state so UI updates immediately
        setQuestion({
            ...question,
            marked: newMarked,
        });

        // Also update session so backend still sees it
        saveAnswerLocally(question.id, question.answer);
    };


    const session = JSON.parse(localStorage.getItem(sessionKey) || "[]");
    const currentIdx = session.findIndex(q => q.id === question?.id);
    const questionNumber =
        currentIdx !== -1
            ? currentIdx + 1
            : (question?.category === "Analytical"
                ? 1
                : (reSume ? currentQuestion.length : 1));


    /* ---------------- Skeleton Loader ---------------- */
    const SkeletonBlock = ({ height }) => (
        <span
            style={{
                display: "block",
                height,
                background: "#e0e0e0",
                borderRadius: "4px",
                marginBottom: "10px",
                animation: "pulse 1.5s infinite",
            }}
        ></span>
    );


    const cleanQuotes = (str) => {
        if (!str) return str;

        return str
            // PDF, OCR, Windows-1252 control quotes
            // eslint-disable-next-line no-control-regex
            .replace(/[\u0000-\u001F]/g, "")   // remove invisible control junk

            // Replace ALL curly/smart quotes with normal ones
            .replace(/[“”«»„‟]/g, '"')         // double quotes
            .replace(/[‘’‚‛]/g, "'")           // single quotes

            // Replace full-width quotes (from OCR)
            .replace(/[\uFF02\uFF07]/g, '"');
    };

    return (
        <div>
            {loading ? <Loader /> :
                <>
                    {
                        startResumeTestError ?
                            <div className='question-container'>
                                {startResumeTestError}
                            </div>
                            :
                            <div className="question-container">
                                <div className="header">
                                    <span className="section" style={{ color: colors?.primaryColor }}>
                                        Section {currentSectionId} of {sections?.length} | Question{" "}
                                        {question?.category === "Analytical" ? "1" : questionNumber} of {reSume ? section?.question_limit : singleSection?.question_limit}
                                        {" "} | {question?.category}
                                    </span>
                                    <div className="timer-wrapper">
                                        {showTimer && (
                                            <span
                                                className="timer btn"
                                                style={{ background: colors?.secondaryButtonBg, color: colors?.buttonText }}
                                            >
                                                {String(timer?.minutes).padStart(2, "0")}:
                                                {String(timer?.seconds).padStart(2, "0")}
                                            </span>)}
                                        <button
                                            onClick={() => setShowTimer(!showTimer)}
                                            className="hide-time">
                                            {showTimer ? "Hide time" : "Show time"}
                                        </button>
                                        {/* <button
                                            onClick={isTimerPaused ? handleStartTimer : handleStopTimer}
                                            className="btn stop-time"
                                            style={{ background: colors?.secondaryButtonBg, color: colors?.buttonText, padding: "6px 10px" }}
                                        >
                                            {isTimerPaused ? "Start Time" : "Stop Time"}
                                        </button> */}
                                        {/* <button className='btn stop-time' style={{ background: colors?.secondaryButtonBg, color: colors?.buttonText, padding: "6px 10px" }}>Stop Time</button> */}
                                    </div>
                                </div>

                                {showReview ? (
                                    <Review reviewData={reviewData} />
                                )
                                    :
                                    <div className="question-block">

                                        {/* <div style={{ marginBottom: "12px" }}>
                                            {isQuestionLoading ?
                                                <span
                                                    style={{
                                                        display: "block",
                                                        width: "200px",
                                                        height: "22px",
                                                        background: "#e0e0e0",
                                                        borderRadius: "4px",
                                                        marginBottom: "10px",
                                                        animation: "pulse 1.5s infinite",
                                                    }}
                                                ></span> :
                                                <strong>ID : {question?.question_id}</strong>
                                            }
                                        </div> */}

                                        {/* question Title */}
                                        <p className="question-text">

                                            {isQuestionLoading ? (
                                                [...Array(1)].map((_, idx) => (
                                                    <span
                                                        key={idx}
                                                        style={{
                                                            display: "block",
                                                            height: "22px",
                                                            background: "#e0e0e0",
                                                            borderRadius: "4px",
                                                            marginBottom: "10px",
                                                            animation: "pulse 1.5s infinite",
                                                        }}
                                                    ></span>
                                                ))
                                            ) : (
                                                // <>
                                                //     {(() => {
                                                //         const parts = ["part1", "part2", "part3", "part4"]
                                                //             .map((key) => question?.[key])
                                                //             .filter(Boolean);

                                                //         // Check if we have both Quantity A and Quantity B
                                                //         const qtyA = parts.find((p) => p.startsWith("Quantity A"));
                                                //         const qtyB = parts.find((p) => p.startsWith("Quantity B"));

                                                //         return parts.map((part, idx) => {
                                                //             // Render Quantity A + B together side by side
                                                //             if (part === qtyA && qtyB) {
                                                //                 return (
                                                //                     <div
                                                //                         key="quantity-ab"
                                                //                         style={{
                                                //                             display: "grid",
                                                //                             gridTemplateColumns: "1fr 1fr",
                                                //                             gap: "40px",
                                                //                             margin: "16px 0",
                                                //                             textAlign: "center",
                                                //                         }}
                                                //                     >
                                                //                         {/* Quantity A */}
                                                //                         <div>
                                                //                             <div style={{ fontWeight: "600", marginBottom: "12px" }}>
                                                //                                 Quantity A
                                                //                             </div>
                                                //                             {qtyA.split("|$|")
                                                //                                 .slice(1) // skip "Quantity A" label
                                                //                                 .map((line, idx) =>
                                                //                                     line.startsWith("http") ? (
                                                //                                         <img
                                                //                                             key={idx}
                                                //                                             src={line}
                                                //                                             alt={`qtyA-${idx}`}
                                                //                                             style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                                //                                         />
                                                //                                     ) : (
                                                //                                         <div key={idx} style={{ marginBottom: "6px" }}>
                                                //                                             {line}
                                                //                                         </div>
                                                //                                     )
                                                //                                 )}
                                                //                         </div>

                                                //                         {/* Quantity B */}
                                                //                         <div>
                                                //                             <div style={{ fontWeight: "600", marginBottom: "12px" }}>
                                                //                                 Quantity B
                                                //                             </div>
                                                //                             {qtyB.split("|$|")
                                                //                                 .slice(1) // skip "Quantity B" label
                                                //                                 .map((line, idx) =>
                                                //                                     line.startsWith("http") ? (
                                                //                                         <img
                                                //                                             key={idx}
                                                //                                             src={line}
                                                //                                             alt={`qtyB-${idx}`}
                                                //                                             style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                                //                                         />
                                                //                                     ) : (
                                                //                                         <div key={idx} style={{ marginBottom: "6px" }}>
                                                //                                             {line}
                                                //                                         </div>
                                                //                                     )
                                                //                                 )}
                                                //                         </div>
                                                //                     </div>
                                                //                 );
                                                //             }

                                                //             // Skip rendering qtyB separately (already shown with A)
                                                //             if (part === qtyB) return null;

                                                //             // Default rendering (for part1, part4, etc.)
                                                //             return (
                                                //                 <div key={idx} style={{ marginBottom: "12px" }}>
                                                //                     {part.split("|$|").map((line, lineIdx) => {
                                                //                         const isImage = line.startsWith("http");
                                                //                         return isImage ? (
                                                //                             <img
                                                //                                 key={lineIdx}
                                                //                                 src={line}
                                                //                                 alt={`part-${idx}-${lineIdx}`}
                                                //                                 style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                                //                             />
                                                //                         ) : (
                                                //                             <div key={lineIdx} style={{ marginBottom: "6px" }}>
                                                //                                 {line}
                                                //                             </div>
                                                //                         );
                                                //                     })}
                                                //                 </div>
                                                //             );
                                                //         });
                                                //     })()}
                                                // </>


                                                // ==================================== //
                                                // <>
                                                //     {(() => {
                                                //         const parts = ["part1", "part2", "part3", "part4"]
                                                //             .map((key) => question?.[key])
                                                //             .filter(Boolean);

                                                //         //  Identify possible label pairs (you can add more here if needed)
                                                //         const PAIRS = [
                                                //             ["Quantity A", "Quantity B"],
                                                //             ["Column A", "Column B"],
                                                //         ];

                                                //         //  Helper: render text or image
                                                //         // const renderLine = (line, key) =>
                                                //         //     line.startsWith("http") ? (
                                                //         //         <img
                                                //         //             key={key}
                                                //         //             src={line}
                                                //         //             alt={`line-${key}`}
                                                //         //             style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                                //         //         />
                                                //         //     ) : (
                                                //         //         <div key={key} style={{ marginBottom: "6px" }}>
                                                //         //             {line}
                                                //         //         </div>
                                                //         //     );

                                                //         // const renderLine = (line, key) => {
                                                //         //     const trimmed = line.trim();

                                                //         //     return trimmed.startsWith("http") ? (
                                                //         //         <img
                                                //         //             key={key}
                                                //         //             src={trimmed}
                                                //         //             alt={`line-${key}`}
                                                //         //             style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                                //         //         />
                                                //         //     ) : (
                                                //         //         <div key={key} style={{ marginBottom: "6px" }}>
                                                //         //             {line}
                                                //         //         </div>
                                                //         //     );
                                                //         // }
                                                //         const renderLine = (line, key) => {
                                                //             const trimmed = line.trim();
                                                //             const text = cleanQuotes(trimmed);

                                                //             return text.startsWith("http") ? (
                                                //                 <img
                                                //                     key={key}
                                                //                     src={text}
                                                //                     alt={`line-${key}`}
                                                //                     style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                                //                 />
                                                //             ) : (
                                                //                 <div key={key} style={{ marginBottom: "6px" }}>
                                                //                     {text}
                                                //                 </div>
                                                //             );
                                                //         }

                                                //         // 🔹 Helper: render one box (A or B)
                                                //         const renderBox = (label, value, key) => (
                                                //             <div key={key}>
                                                //                 <div style={{ fontWeight: "600", marginBottom: "8px" }}>{label}</div>
                                                //                 {value
                                                //                     .split("|$|")
                                                //                     .slice(1)
                                                //                     .map((line, idx) => renderLine(line, `${label}-${idx}`))}
                                                //             </div>
                                                //         );

                                                //         return parts.map((part, idx) => {
                                                //             // check if this part belongs to any pair (e.g. Quantity A & B or Column A & B)
                                                //             // const pair = PAIRS.find(([a, b]) =>
                                                //             //     part.startsWith(a) || part.startsWith(b)
                                                //             // );

                                                //             const pair = PAIRS.find(([a, b]) => {
                                                //                 // VALID ONLY IF contains |$|
                                                //                 if (!part.includes("|$|")) return false;

                                                //                 const label = part.split("|$|")[0];
                                                //                 return label === a || label === b;
                                                //             });

                                                //             console.log("pair", pair)


                                                //             if (pair) {
                                                //                 const [labelA, labelB] = pair;
                                                //                 console.log("Current part:", parts);
                                                //                 const partA = parts.find((p) => p.startsWith(labelA));
                                                //                 const partB = parts.find((p) => p.startsWith(labelB));

                                                //                 console.log("Rendering paired parts:", { labelA, labelB, partA, partB });

                                                //                 // only render once (when we hit A)
                                                //                 if (part === partA && partB) {
                                                //                     return (
                                                //                         <div
                                                //                             key={`${labelA}-${labelB}`}
                                                //                             style={{
                                                //                                 display: "grid",
                                                //                                 gridTemplateColumns: "1fr 1fr",
                                                //                                 gap: "40px",
                                                //                                 margin: "16px 0",
                                                //                                 textAlign: "center",
                                                //                             }}
                                                //                         >
                                                //                             {renderBox(labelA, partA, "A")}
                                                //                             {renderBox(labelB, partB, "B")}
                                                //                         </div>
                                                //                     );
                                                //                 }

                                                //                 // Skip rendering the second one (B) separately
                                                //                 if (part === partB) return null;
                                                //             }

                                                //             //  Default rendering (for everything else)
                                                //             return (
                                                //                 <div key={idx} style={{ marginBottom: "12px" }}>
                                                //                     {part.split("|$|").map((line, lineIdx) =>
                                                //                         renderLine(line, `part-${idx}-${lineIdx}`)
                                                //                     )}
                                                //                 </div>
                                                //             );
                                                //         });
                                                //     })()}
                                                // </>
                                                <>
                                                    {(() => {
                                                        const parts = ["part1", "part2", "part3", "part4"]
                                                            .map((key) => question?.[key])
                                                            .filter(Boolean);

                                                        // Possible label pairs
                                                        const PAIRS = [
                                                            ["Quantity A", "Quantity B"],
                                                            ["Column A", "Column B"],
                                                        ];

                                                        // Fix Unicode look-alike characters (Cyrillic A, B, etc.)
                                                        const normalize = (str = "") =>
                                                            cleanQuotes(str)
                                                                .trim()
                                                                .replace(/А/g, "A") // Cyrillic A → Latin A
                                                                .replace(/В/g, "B") // Cyrillic Ve → Latin B
                                                                .replace(/\s+/g, " ");

                                                        const renderLine = (line, key) => {
                                                            const text = normalize(line.trim());

                                                            return text.startsWith("http") ? (
                                                                <img
                                                                    key={key}
                                                                    src={text}
                                                                    alt={`line-${key}`}
                                                                    style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                                                />
                                                            ) : (
                                                                <div key={key} style={{ marginBottom: "6px" }}>
                                                                    {text}
                                                                </div>
                                                            );
                                                        };

                                                        const renderBox = (label, value, key) => (
                                                            <div key={key}>
                                                                <div style={{ fontWeight: "600", marginBottom: "8px" }}>{label}</div>
                                                                {value
                                                                    .split("|$|")
                                                                    .slice(1)
                                                                    .map((line, idx) => renderLine(line, `${label}-${idx}`))}
                                                            </div>
                                                        );

                                                        return parts.map((originalPart, idx) => {
                                                            const normalizedPart = normalize(originalPart);

                                                            // -------- Detect which pair this part belongs to --------
                                                            const pair = PAIRS.find(([a, b]) => {
                                                                if (!normalizedPart.includes("|$|")) return false;

                                                                const label = normalize(normalizedPart.split("|$|")[0]);
                                                                return label === normalize(a) || label === normalize(b);
                                                            });

                                                            if (pair) {
                                                                const [labelA, labelB] = pair;

                                                                // -------- Find actual parts for A and B --------
                                                                const partA = parts.find(
                                                                    (p) => normalize(p.split("|$|")[0]) === normalize(labelA)
                                                                );

                                                                const partB = parts.find(
                                                                    (p) => normalize(p.split("|$|")[0]) === normalize(labelB)
                                                                );


                                                                // Render only when encountering A (avoid double rendering)
                                                                if (originalPart === partA && partB) {
                                                                    return (
                                                                        <div
                                                                            key={`${labelA}-${labelB}`}
                                                                            style={{
                                                                                display: "grid",
                                                                                gridTemplateColumns: "1fr 1fr",
                                                                                gap: "40px",
                                                                                margin: "16px 0",
                                                                                textAlign: "center",
                                                                            }}
                                                                        >
                                                                            {renderBox(labelA, partA, "A")}
                                                                            {renderBox(labelB, partB, "B")}
                                                                        </div>
                                                                    );
                                                                }

                                                                // Skip rendering B separately
                                                                if (originalPart === partB) return null;
                                                            }

                                                            // -------- Default rendering (non-paired parts) --------
                                                            return (
                                                                <div key={idx} style={{ marginBottom: "12px" }}>
                                                                    {originalPart
                                                                        .split("|$|")
                                                                        .map((line, lineIdx) =>
                                                                            renderLine(line, `part-${idx}-${lineIdx}`)
                                                                        )}
                                                                </div>
                                                            );
                                                        });
                                                    })()}
                                                </>

                                            )}
                                        </p>

                                        {!isQuestionLoading && (question?.input_field?.toLowerCase() === "single" || question?.input_field?.toLowerCase() === "multi") &&
                                            <p className="instruction">Select {question?.input_field?.toLowerCase() === "single" ? "One" : "Multi"} Answer Choice.</p>
                                        }
                                        {/* answer field Type */}
                                        {question?.input_field?.toLowerCase() === "textarea" ? (
                                            //  Essay type
                                            <>
                                                {isQuestionLoading ? (
                                                    <SkeletonBlock height="200px" />
                                                ) : (
                                                    <div style={{ width: "100%" }}>
                                                        <textarea
                                                            value={essayAnswer}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setEssayAnswer(value);
                                                                localStorage.setItem(`essay_answer`, value);
                                                            }}
                                                            placeholder="Write your essay here..."
                                                            style={{ width: "100%", padding: "20px" }}
                                                            rows={10}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        ) : question?.input_field?.toLowerCase() === "input" ? (
                                            //  Input fields type
                                            <>
                                                {isQuestionLoading ? (
                                                    <SkeletonBlock height="40px" />
                                                ) : (
                                                    <div style={{ marginTop: "16px" }}>
                                                        <input
                                                            id="inputAnswer"
                                                            name="inputAnswer"
                                                            type="text"
                                                            value={inputAnswer}
                                                            onChange={(e) => setInputAnswer(e.target.value)}
                                                            placeholder="Enter your answer"
                                                            style={{
                                                                width: "100%",
                                                                padding: "12px",
                                                                borderRadius: "6px",
                                                                border: "1px solid #ccc",
                                                            }}
                                                        />
                                                    </div>
                                                )
                                                }
                                            </>
                                        ) : (
                                            //  Normal multiple-choice options
                                            <>
                                                <div className="options">
                                                    {isQuestionLoading ? (
                                                        // Skeleton loader (show 5 blocks)
                                                        [...Array(5)].map((_, idx) => (
                                                            <SkeletonBlock key={idx} height="40px" />
                                                        ))
                                                    ) : (
                                                        <>
                                                            {options.map((opt, idx) => {
                                                                const optionLetter = String.fromCharCode(65 + idx);
                                                                const isSelected = selectedOptions.includes(optionLetter);
                                                                const isImage = typeof opt === "string" && opt.startsWith("http");

                                                                const handleOptionClick = () => {
                                                                    if (question?.input_field?.toLowerCase() === "single") {
                                                                        // allow only one
                                                                        setSelectedOptions([optionLetter]);
                                                                    } else if (question?.input_field?.toLowerCase() === "multi") {
                                                                        // allow multiple
                                                                        if (isSelected) {
                                                                            setSelectedOptions(selectedOptions.filter((o) => o !== optionLetter));
                                                                        } else {
                                                                            setSelectedOptions([...selectedOptions, optionLetter]);
                                                                        }
                                                                    }
                                                                };

                                                                return (
                                                                    // <button
                                                                    //     key={idx}
                                                                    //     className={`option ${isSelected ? "selected" : ""}`}
                                                                    //     onClick={handleOptionClick}
                                                                    // >
                                                                    //     <strong style={{ marginRight: "6px" }}>{optionLetter}.</strong>
                                                                    //     {isImage ? (
                                                                    //         <img
                                                                    //             src={opt}
                                                                    //             alt={`Option ${optionLetter}`}
                                                                    //             style={{ height: "28px", objectFit: "contain" }}
                                                                    //         />
                                                                    //     ) : (
                                                                    //         <span>{opt}</span>
                                                                    //     )}
                                                                    // </button>
                                                                    <label
                                                                        key={idx}
                                                                        className={`option ${isSelected ? "selected" : ""}`}
                                                                    >
                                                                        {/* Radio for Single | Checkbox for Multi */}
                                                                        <input
                                                                            type={question?.input_field?.toLowerCase() === "single" ? "radio" : "checkbox"}
                                                                            name={`question-${question?.id}`} // keep radios grouped
                                                                            id={`question-${question?.id}`}
                                                                            checked={isSelected}
                                                                            onChange={handleOptionClick}
                                                                            className="cursor-pointer"
                                                                        />

                                                                        <strong>{optionLetter}.</strong>

                                                                        {isImage ? (
                                                                            <img
                                                                                src={opt}
                                                                                alt={`Option ${optionLetter}`}
                                                                                style={{ height: "28px", objectFit: "contain" }}
                                                                            />
                                                                        ) : (
                                                                            <span>{opt}</span>
                                                                        )}
                                                                    </label>
                                                                );
                                                            })}
                                                        </>
                                                    )}
                                                </div>
                                                {/* {!isQuestionLoading && <p className="instruction">Select {question?.input_field?.toLowerCase() === "single" ? "One" : "Multi"} Answer Choice.</p>} */}
                                            </>
                                        )}
                                    </div>
                                }

                                <div className="footer-buttons">
                                    <button
                                        onClick={() => setShowExitPopup(true)}
                                        className="btn footer-button " style={{ background: colors?.secondaryButtonBg, color: colors?.buttonText }}>
                                        Exit
                                    </button>
                                    <button
                                        onClick={() => setShowQuitPopup(true)}
                                        // disabled={isTimerPaused}
                                        className="btn footer-button "
                                        style={{
                                            background: colors?.secondaryButtonBg, color: colors?.buttonText,
                                            // opacity: isTimerPaused ? 0.7 : 1,
                                            // cursor: isTimerPaused ? "not-allowed" : "pointer",
                                        }}>
                                        Quit w/Save
                                    </button>
                                    <button
                                        onClick={() => setShowCalc(!showCalc)}
                                        className="btn footer-button " style={{ background: colors?.secondaryButtonBg, color: colors?.buttonText }}>
                                        Calc
                                    </button>
                                    <button
                                        onClick={handleMark}
                                        className="btn footer-button " style={{ background: colors?.secondaryButtonBg, color: colors?.buttonText }}>
                                        {question?.marked ? "Unmark" : "Mark"}
                                    </button>
                                    <button
                                        onClick={() => { buildReviewData(); setShowReview(!showReview); }}
                                        className="btn footer-button " style={{ background: colors?.secondaryButtonBg, color: colors?.buttonText }}>
                                        {showReview ? "Close Review" : "Review"}
                                    </button>
                                    <button
                                        onClick={() => setIsOpen(true)}
                                        className="btn footer-button " style={{ background: colors?.secondaryButtonBg, color: colors?.buttonText }}>
                                        Help
                                    </button>
                                    <button
                                        disabled={
                                            // isTimerPaused ||
                                            JSON.parse(localStorage.getItem(sessionKey) || "[]")
                                                .findIndex((q) => q.id === question?.id) === 0 || question?.category === "Analytical"
                                        }
                                        onClick={handleBack}
                                        style={{
                                            background:
                                                JSON.parse(localStorage.getItem(sessionKey) || "[]")
                                                    .findIndex((q) => q.id === question?.id) === 0 || question?.category === "Analytical"
                                                    ? "#ccc"
                                                    : colors?.buttonBg,
                                            color: colors?.buttonText,
                                            // opacity: isTimerPaused ? 0.7 : 1,
                                            cursor:
                                                JSON.parse(localStorage.getItem(sessionKey) || "[]")
                                                    .findIndex((q) => q.id === question?.id) === 0 || question?.category === "Analytical"
                                            // || isTimerPaused ? "not-allowed" : "pointer",
                                        }}
                                        className="footer-button"
                                    >
                                        Back
                                    </button>

                                    <button
                                        className="footer-button"
                                        style={{
                                            background: colors?.buttonBg, color: colors?.buttonText,
                                            //  opacity: isTimerPaused ? 0.7 : 1,
                                            // cursor: isTimerPaused ? "not-allowed" : "pointer",
                                        }}
                                        onClick={handleSubmitQuestion}
                                    // disabled={isTimerPaused}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                    }
                </>
            }

            <GreInstructionsModal
                open={isOpen}
                onClose={() => handleStartAfterInstructions()}
                onContinue={() => handleStartAfterInstructions()}
            />

            {showLogin && <LoginPopup onLoginSuccess={handleLoginSuccess} />}

            {showQuitPopup && (
                <div className="modal-overlay">
                    <div className="modal-content" style={{ background: colors.popupBg }}>
                        <h2>Are you sure you want to submit your answers for this
                            section and quit it?</h2>
                        <p>
                            Clicking 'Quit w/Save' will close this section with saving your answers.You will not be able to return to this section to review or answer any unanswered questions.
                        </p>
                        <div className="modal-buttons">
                            <button className="btn border-btn" onClick={() => setShowQuitPopup(false)}
                                style={{ backgroundColor: "transparent", borderColor: colors.buttonBg }}
                            >
                                Cancel
                            </button>
                            <button onClick={() => handleSubmitSection()} className="btn black"
                                style={{ backgroundColor: colors.buttonBg }}
                            >Submit</button>
                        </div>
                    </div>
                </div>
            )}

            {showExitPopup && (
                <div className="modal-overlay">
                    <div className="modal-content" style={{ background: colors.popupBg }}>
                        <h2>Are you sure you want to exit?</h2>
                        <p>
                            Clicking 'Submit' will close test..
                        </p>
                        <div className="modal-buttons">
                            <button className="btn border-btn" onClick={() => setShowExitPopup(false)}
                                style={{ backgroundColor: "transparent", borderColor: colors.buttonBg }}
                            >
                                Cancel
                            </button>
                            <button onClick={() => handleExit()} className="btn black"
                                style={{ backgroundColor: colors.buttonBg }}
                            >Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showCalc && <CalculatorPopup onClose={() => setShowCalc(false)} />}

        </div >
    );
};

export default TestComponents;